/**
 * File utility functions for importing and exporting data
 */
/**
 * Load data from a JSON file
 */
function loadFromFile() {
    return new Promise((resolve) => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.json';
        input.style.display = 'none';
        input.addEventListener('change', async (e) => {
            const file = e.target.files?.[0];
            if (!file) {
                resolve(null);
                return;
            }
            try {
                const text = await file.text();
                const data = JSON.parse(text);
                resolve(data);
            }
            catch (error) {
                console.error('Error reading file:', error);
                alert('Error reading file: ' + (error instanceof Error ? error.message : 'Unknown error'));
                resolve(null);
            }
        });
        input.addEventListener('cancel', () => {
            resolve(null);
        });
        document.body.appendChild(input);
        input.click();
        document.body.removeChild(input);
    });
}
/**
 * Export data to a JSON file
 */
function exportToFile(data, filename) {
    try {
        const json = JSON.stringify(data, null, 2);
        const blob = new Blob([json], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename.endsWith('.json') ? filename : `${filename}.json`;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }
    catch (error) {
        console.error('Error exporting file:', error);
        alert('Error exporting file: ' + (error instanceof Error ? error.message : 'Unknown error'));
    }
}
/**
 * Download text as a file
 */
function downloadTextFile(content, filename, mimeType = 'text/plain') {
    try {
        const blob = new Blob([content], { type: mimeType });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }
    catch (error) {
        console.error('Error downloading file:', error);
        alert('Error downloading file: ' + (error instanceof Error ? error.message : 'Unknown error'));
    }
}

export { downloadTextFile, exportToFile, loadFromFile };
//# sourceMappingURL=utils.esm.js.map
